import "@aws-amplify/ui-react/styles.css";
import React, { useEffect } from "react";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import { browserRouter } from "./app/BrowserRouter";
import { useDispatch } from "react-redux";
function App() {
  const dispatch = useDispatch();

  return (
    <>
      <RouterProvider router={browserRouter} />
    </>
  );
}

export default App;
